module.exports = __webpack_public_path__ + "img/event_2605.bb953807.png";